import * as t from 'io-ts'

import * as tv from '@espoon-voltti/ts-libs/lib/io-ts-types'
import { Event } from '@espoon-voltti/nuora-domain/grants'

import {
  TransactionDto,
  AttachmentDto
} from '@espoon-voltti/nuora-app-common/services/dtos'

export const ProjectGrantFormDataDto = t.type({
  type: t.union([t.literal('PROJECT_GRANT'), t.literal('PROJECT_GRANT_PAPER')]),
  event: Event,
  appliedSumInCents: t.union([t.number, t.null]),
  purpose: t.union([t.string, t.null]),
  participants: t.type({
    ages7to20: t.union([t.number, t.null]),
    ages21to28: t.union([t.number, t.null]),
    ages29andOver: t.union([t.number, t.null])
  }),
  expenses: t.array(TransactionDto),
  incomes: t.array(TransactionDto),
  attachments: t.array(AttachmentDto)
})
export type ProjectGrantFormDataDto = t.TypeOf<typeof ProjectGrantFormDataDto>

export const GeneralGrantFormDataDto = t.type({
  type: t.literal('GENERAL_GRANT'),
  appliedSumInCents: t.union([t.number, t.null]),
  detailsOfUse: t.union([t.string, t.null]),
  participants: t.type({
    ages7to20: t.union([t.number, t.null]),
    ages21to28: t.union([t.number, t.null])
  }),
  goals: t.type({
    goals1: t.union([t.string, t.null]),
    goals2: t.union([t.string, t.null]),
    goals3: t.union([t.string, t.null])
  }),
  youngEspoo: t.union([t.string, t.null]),
  financialPlan: t.union([t.string, t.null]),
  previousYear: t.type({
    totalProfitInCents: t.union([tv.euroCentsFromNumber, t.null]),
    bankAccountSumInCents: t.union([tv.euroCentsFromNumber, t.null]),
    selfAcquiredFundsInCents: t.union([tv.euroCentsFromNumber, t.null]),
    receivedGrants: t.union([t.string, t.null])
  }),
  attachments: t.array(AttachmentDto)
})
export type GeneralGrantFormDataDto = t.TypeOf<typeof GeneralGrantFormDataDto>

export const GeneralGrantPaperFormDataDto = t.type({
  type: t.literal('GENERAL_GRANT_PAPER'),
  appliedSumInCents: t.union([t.number, t.null]),
  detailsOfUse: t.union([t.string, t.null]),
  participants: t.type({
    ages7to20: t.union([t.number, t.null]),
    ages21to28: t.union([t.number, t.null])
  }),
  previousYear: t.type({
    totalProfitInCents: t.union([tv.euroCentsFromNumber, t.null]),
    bankAccountSumInCents: t.union([tv.euroCentsFromNumber, t.null]),
    selfAcquiredFundsInCents: t.union([tv.euroCentsFromNumber, t.null])
  }),
  attachments: t.array(AttachmentDto)
})
export type GeneralGrantPaperFormDataDto = t.TypeOf<
  typeof GeneralGrantPaperFormDataDto
>

export const FormDataDto = t.union([
  ProjectGrantFormDataDto,
  GeneralGrantFormDataDto
])
export type FormDataDto = t.TypeOf<typeof FormDataDto>
